import { useState, useEffect, useRef } from 'react';
import '../styles/chat.scss';
import SendIcon from '@mui/icons-material/Send';
import { IconButton, Avatar } from '@mui/material';
import { useUnit } from 'effector-react';
import { $chatMessages, $chatSocketConnection, $userData, setChatMessages, setNotificationMessage, setShowNotification } from '../store';
import { markAsReadMessages } from './api';

export const Chat = () => {
    const messages = useUnit($chatMessages);
    const [newMessage, setNewMessage] = useState('');
    const messagesEndRef = useRef(null);
    const messagesContainerRef = useRef(null);
    const connection = useUnit($chatSocketConnection);
    const userData = useUnit($userData);

    useEffect(() => {
        const unreadMessages = messages.filter(message => !message.read && message.senderId !== userData.id);
        if(unreadMessages.length > 0) {
            markAsReadMessages()
            .then(() => {
                const readedMessages = messages.map(message => {
                    message.read = true;
                    return message;
                })
                setChatMessages(readedMessages);
            })
            .catch(err => console.error(err));
        }
        scrollToBottom();
    }, [messages]);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView();
    };

    const handleSendMessage = async () => {
        if (newMessage.trim() && connection) {
            try {
                await connection.invoke("SendMessageToAuctioneer", newMessage);
                setNewMessage('');
            } catch (err) {
                console.error('Error sending message:', err);
                setNotificationMessage(`Ошибка отправки сообщения. ${err.message}`);
                setShowNotification(true);
            }
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    const formatTime = (date) => {
        return new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div className="chat chat--embedded">
            <div className="chat__header">
                <div className="chat__header-info">
                    <Avatar className="chat__avatar">
                        А
                    </Avatar>
                    <div className="chat__header-text">
                        <h3 className="chat__title">Чат с аукционистом</h3>
                        <div className="chat__status">
                            <span className="chat__status-dot" />
                            <span className="chat__status-text">Онлайн</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="chat__messages" ref={messagesContainerRef}>
                {messages.map((message) => (
                    <div
                        key={message.id}
                        className={`chat__message ${message.senderId === userData.id ? 'chat__message--own' : 'chat__message--other'}`}
                    >
                        <div className="chat__message-bubble">
                            <div className="chat__message-text">
                                {message.text}
                            </div>
                            <div className="chat__message-time">
                                {formatTime(message.date)}
                            </div>
                        </div>
                    </div>
                ))}
                <div ref={messagesEndRef} />
            </div>

            <div className="chat__input-container">
                {!userData.chatIsBlocked ?
                    <div className="chat__input-wrapper">
                        <textarea
                            className="chat__input"
                            placeholder="Напишите сообщение..."
                            value={newMessage}
                            onChange={(e) => setNewMessage(e.target.value)}
                            onKeyDown={handleKeyPress}
                            rows={1}
                        />
                        <div className="chat__input-actions">
                            <IconButton
                                className="chat__send-btn"
                                onClick={handleSendMessage}
                                disabled={!newMessage.trim()}
                                size="small"
                            >
                                <SendIcon />
                            </IconButton>
                        </div>
                    </div>
                    : <span className='chat__block-text'> Отправка сообщений ограничена администратором аукциона</span>
                }
            </div>
        </div>
    );
};